import { REPEAT_RULE_OPTIONS } from "@/consts";
import type { PrimitiveModel } from "@/types";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

// On the planner template repeat options, we only allow weekly and monthly
// repeat options.
const ALLOWED_REPEAT_RULE_OPTIONS: PrimitiveModel[] = [7, 30];

export function usePlannerTemplateRepeats() {
  const { t } = useI18n();

  const possibleRepeatRuleOptions = REPEAT_RULE_OPTIONS.filter(
    (item) =>
      item.value === null || ALLOWED_REPEAT_RULE_OPTIONS.includes(item.value),
  ).map((option) => {
    return {
      ...option,
      title: t(option.title),
    };
  });

  const repeatRuleOptions = computed(() => {
    return possibleRepeatRuleOptions.filter((item) => item.value !== null);
  });

  return {
    possibleRepeatRuleOptions,
    repeatRuleOptions,
  };
}
